<div class="w-100 float-left">
    <div class="w-100 float-left v-align relative" (click)="clicked();closeEmployeeFilter()">
        <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
            <h5 class="medium m-0">{{'users' | translate}}</h5>
            <div style="flex-grow: 1;"></div>
            <button class="btn btn-primary float-right mr-3" (click)="addEmployees()"> {{'addUsers' | translate}}
            </button>
        </div>
    </div>

    <div (click)="clicked()">
        <employeeFilter [displayTab]="'employeeSearch'" (searchEmp)="showSearchFilter($event)"></employeeFilter>
    </div>

    <!-- EMPLOYEE DETAILS GRID -->
    <div class="w-100 float-left mt-3" (click)="closeEmployeeFilter()">
        <div class="light-bg w-100 float-left p-2 grid-details" (click)="closeEmployeeFilter()">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium"> {{'userId' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium"> {{'licenceNumber' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium"> {{'name' | translate}} </h6>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium">{{'orgUit' | translate}}</h6>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'designation' | translate}} </h6>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                <h6 class="mb-lg-0 medium"> {{'supervisor' | translate}} </h6>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium">{{'icVerified' | translate}}</h6>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                <h6 class="mb-lg-0 medium">{{'status' | translate}}</h6>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                <h6 class="mb-lg-0 medium"> {{'actions' | translate}} </h6>
            </div>
        </div>
        <ng-container *ngIf="employeeData.length > 0">
            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let employee of employeeData; let i=index">
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 [copy-clipboard]="employee.userName" (copied)="notify($event)"
                        class="mb-lg-0 text-truncate text-primary" (click)="editEmployeeProfile(employee.id)"
                        ngbTooltip='{{employee.userName}}'> {{employee.userName}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 [copy-clipboard]="employee.licenceNumber" (copied)="notify($event)"
                        class="mb-lg-0 text-truncate" ngbTooltip='{{employee.licenceNumber}}'>
                        {{employee.licenceNumber}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left align-v-center">
                    <img class="w-16 mr-2" *ngIf="employee.imageUrl" [src]="employee.imageUrl">
                    <img class="w-16 mr-2" *ngIf="!employee.imageUrl" src="assets/img/profilePic.png">
                    <h6 [copy-clipboard]="employee.displayName" (copied)="notify($event)" class="mb-lg-0 text-truncate"
                        ngbTooltip='{{employee.displayName}}'>
                        {{employee.displayName}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 [copy-clipboard]="employee.orgName +'('+employee.orgCode+')'" (copied)="notify($event)"
                        class="mb-lg-0 text-truncate" *ngIf="employee.orgId != null" ngbTooltip='{{employee.orgName}}'>
                        {{employee.orgName}}
                        ({{employee.orgCode}}) </h6>
                    <h6 class="mb-lg-0 text-truncate" *ngIf="employee.orgId == null">{{'notAvailable' | translate}}
                    </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 [copy-clipboard]="employee.designationName" (copied)="notify($event)"
                        class="mb-lg-0 text-truncate" ngbTooltip='{{employee.designationName}}'
                        *ngIf="employee.designationName != null">
                        {{employee.designationName}} </h6>
                    <h6 class="mb-lg-0 text-truncate" *ngIf="employee.designationName == null"> {{'notAvailable' |
                        translate}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 [copy-clipboard]="employee.supervisorUserName" (copied)="notify($event)"
                        class="mb-lg-0 text-truncate"
                        ngbTooltip='{{employee.supervisorName}}({{employee.supervisorUserName}})'
                        *ngIf="employee.supervisorName">
                        {{employee.supervisorName}}({{employee.supervisorUserName}})</h6>
                    <h6 class="mb-lg-0 text-truncate" *ngIf="!employee.supervisorName"> {{'notAvailable' |
                        translate}}</h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 medium">{{employee.nonVaccineAccount?'Non Vaccine
                        Account':(employee.icVerified?'Yes':'No')}}</h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6>{{employee.status | empStatus | translate}}</h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative">
                    <h6 class="mb-lg-0" (click)="empTableActions(i)" ngbTooltip="{{'clickForMoreOption' | translate}}">
                        <i class="fa fa-ellipsis-h"></i>
                    </h6>
                    <div class="empActions m-t-nsmd" *ngIf="i == trackHides">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="editEmployeeProfile(employee.id)" *ngIf="employee.status == 1">
                                <i class="fa fa-pencil mr-2"></i> {{'edit' | translate}}
                            </li>

                            <li (click)="openEditModal(employeeModal, employee)" *ngIf="employee.status == 1">
                                <i class="fa fa-pencil mr-2"></i> {{'editProfile' | translate}}
                            </li>

                            <li (click)="reloadEmployee(employee.id)" *ngIf="employee.status == 1">
                                <i class="fa fa-refresh mr-2"></i> {{'reloadEmployee' | translate}}
                            </li>
                            <li (click)="openChangeIdModal(changeIdModal, employee)" *ngIf="employee.status == 1">
                                <i class="fa fa-id-badge mr-2"></i> {{'changeId' | translate}}
                            </li>
                            <li (click)="resolveCertErrors(employee.id)"
                                *ngIf="employee.status == 1 && employee.icVerified">
                                <i class="fa fa-pencil mr-2"></i> {{'resolveCertErrors' | translate}}
                            </li>

                            <li (click)="openRoleModal(changeRoleModal, employee.id)" *ngIf="employee.status == 1">
                                <i class="fa fa-user mr-2"></i>Change Role
                            </li>

                            <li (click)="removeLabTest(employee.licenceNumber)" *ngIf="employee.status == 1">
                                <i class="fa fa-address-card mr-2"></i>Remove LabTest
                            </li>

                            <li (click)="removeHSOBadge(employee.userName)" *ngIf="employee.status == 1">
                                <i class="fa fa-unlock mr-2"></i>Remove HSO badge
                            </li>

                            <li (click)="empTableResetPwd(employee.id)" *ngIf="employee.status == 1">
                                <i class="fa fa-key mr-2"></i> {{'resetPassword' | translate}}
                            </li>
                            <li (click)="actionSuspend(employee.id)" *ngIf="employee.status == 1">
                                <i class="fa fa-power-off mr-2"></i> {{'suspend' | translate}}
                            </li>
                            <li (click)="actionResign(employee.id)" *ngIf="employee.status == 1">
                                <i class="fa fa-sign-out mr-2"></i> {{'resign' | translate}}
                            </li>
                            <li (click)="actionRemoveEmployee(employee.userName)" *ngIf="employee.status == 1">
                                <i class="fa fa-times mr-2"></i> {{'delete' | translate}}
                            </li>
                            <li (click)="resetToDay0(employee.id)" *ngIf="employee.status == 1">
                                <i class="fa fa-repeat mr-2"></i> {{'resetToDay0' | translate}}
                            </li>
                            <li (click)="addLocationAssessment(employee.id)"
                                *ngIf="(employee.status == 1 && (employee.gradeName == null || employee.gradeName == ''))">
                                <i class="fa fa-repeat mr-2"></i> {{'addLocationAssessment' | translate}}
                            </li>
                            <li (click)="convertToLowRisk(employee.id)"
                                *ngIf="(employee.status == 1 && (employee.designationCode == null || employee.designationCode != 'LOW_RISK_NS'))">
                                <i class="fa fa-repeat mr-2"></i> {{'convertToLowRisk' | translate}}
                            </li>
                            <li (click)="convertToConfirmedCase(employee.id)"
                                *ngIf="(employee.status == 1 && employee.transferredDate==null)">
                                <i class="fa fa-repeat mr-2"></i> {{'convertToConfirmedCase' | translate}}
                            </li>
                            <li (click)="revertICVerification(employee.id)"
                                *ngIf="(employee.status == 1 && employee.icVerified)">
                                <i class="fa fa-repeat mr-2"></i> {{'revertICVerification' | translate}}
                            </li>
                            <li (click)="revertNonVaccineAccount(employee.id)"
                                *ngIf="(employee.status == 1 && employee.nonVaccineAccount)">
                                <i class="fa fa-repeat mr-2"></i> Revert Non Vaccine account
                            </li>
                            <li (click)="addMentalAssessment(employee.id)"
                                *ngIf="(employee.status == 1 && (employee.gradeName == null || employee.gradeName == ''))">
                                <i class="fa fa-repeat mr-2"></i> {{'addMentalAssessment' | translate}}
                            </li>
                            <li (click)="activateEmployeeProfile(employee.id)" *ngIf="employee.status != 1">
                                <i class="fa fa-check-circle mr-2"></i> {{'ACTIVE' | translate}}
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </ng-container>
        <ng-container *ngIf="employeeData.length == 0">
            <div class="w-100 float-left min-h2 relative" *ngIf="showLoading">
                <div class="loader-div">
                    <div class="loader-gif"></div>
                </div>
            </div>
            <div class="w-100 float-left p-4 grid-details" *ngIf="!showLoading">
                <p class="text-center m-0 w-100 medium">{{'noResultFound' | translate}}</p>
            </div>
        </ng-container>
    </div>

    <!-- PAGINATION -->
    <div class="w-100 float-left my-4 light-bg p-3 align-v-center" (click)="clicked();closeEmployeeFilter()">
        <h6 class="float-left mb-0 mr-4"> {{((searchData.page-1)*searchData.pageSize)+1}} -
            {{searchData.pageSize*(searchData.page-1)+employeePageData.numberOfElements}}
            {{'itemsOf' | translate}} {{employeePageData.totalElements}} </h6>
        <div class="float-left ml-2 align-v-center">
            <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
            <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="searchData.pageSize"
                (change)="onPageSizeChange()">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
            </select>
        </div>
        <div style="flex-grow: 1;"></div>
        <ngb-pagination [collectionSize]="employeePageData.totalElements" [rotate]="true"
            [pageSize]="searchData.pageSize" [(page)]="searchData.page" [boundaryLinks]="true" [maxSize]="5"
            [ellipses]="false" (pageChange)="getEmployee()" [maxSize]="5" class="float-right"></ngb-pagination>
        <div (click)="onRefresh()" data-toggle="tooltip" data-placement="bottom" title="Refresh"
            style="margin-right:1px; margin-left:10px;cursor: pointer;"><i class="fa fa-refresh" aria-hidden="true"></i>
        </div>
    </div>

</div>

<!-- Change role modal -->
<ng-template #changeRoleModal let-modal>
    <div id="divdata">
        <div class="modal-header">
            <h6 class="modal-title medium">Change role</h6>
            <button type="button" class="close" aria-label="Close" (click)="closeRoleModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="w-100 float-left p-4 modal-body">

            <div class="form-group">
                <h6 class="mb-2 medium">Please select a role *</h6>

                <select id="role_list" [(ngModel)]="_newRole" class="form-select" aria-label="">
                    <option *ngFor='let role of roles; let j = index' [attr.value]='role'>
                        <h5 class="mb-lg-0 text-truncate">{{getRoleLabel(role)}}</h5>
                    </option>
                </select>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="changeRole(confirmationModal)">Change</button>

        </div>
    </div>
</ng-template>

<!-- Change role modal -->
<ng-template #changeIdModal let-modal>
    <div id="divdata">
        <div class="modal-header">
            <h6 class="modal-title medium">Change MySJ ID​</h6>
            <button type="button" class="close" aria-label="Close" (click)="closeRoleModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="w-100 float-left modal-body">

            <div class="form-group">


                <div class="w-100 float-left p-md-2">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"
                        ng-reflect-ngb-tooltip="Current MySJ ID">
                        Current MySJ ID:
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left" id="currentMYSJId"
                        ng-reflect-ngb-tooltip="1">
                        {{_activeEmployee ? _activeEmployee.userName : '-'}}
                    </div>
                </div>

                <div class="w-100 float-left p-md-2">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ng-reflect-ngb-tooltip="New MySJ ID">
                        New MySJ ID:
                    </div>
                    <div *ngIf="_newMYSJType == 1" class="form-group" style="margin:0px;">
                        <div class="row">
                            <div class="col-5 form-group has-float-label required">
                                <select [(ngModel)]="_newMYSJCounCode" class="form-control custom-select"
                                    name="countryCode" id="countryCode">

                                    <option data-countrycode="MY" value="60">Malaysia (+60)</option>
                                    <option data-countrycode="CN" value="86">China (+86)</option>
                                    <option data-countrycode="JP" value="81">Japan (+81)</option>
                                    <option data-countrycode="KR" value="82">South Korea (+82)</option>
                                    <option data-countrycode="IR" value="98">Iran (+98)</option>
                                    <option data-countrycode="IT" value="39">Italy (+39)</option>
                                    <option data-countrycode="SG" value="65">Singapore (+65)</option>
                                    <option data-countrycode="AU" value="61">Australia (+61)</option>
                                    <option data-countrycode="IN" value="91">India (+91)</option>
                                    <option data-countrycode="TH" value="66">Thailand (+66)</option>
                                    <optgroup label="Other countries">
                                        <option data-countrycode="AFG" value="93">Afghanistan (+93)</option>
                                        <option data-countrycode="ALB" value="355">Albania (+355)</option>
                                        <option data-countrycode="DZ" value="213">Algeria (+213)</option>
                                        <option data-countrycode="ALA" value="35818">Åland Islands (+35818)</option>
                                        <option data-countrycode="ASM" value="684">American Samoa (+684)</option>
                                        <option data-countrycode="AD" value="376">Andorra (+376)</option>
                                        <option data-countrycode="AO" value="244">Angola (+244)</option>
                                        <option data-countrycode="AI" value="1264">Anguilla (+1264)</option>
                                        <option data-countrycode="ATA" value="672">Antarctica (+672)</option>
                                        <option data-countrycode="AG" value="1268">Antigua &amp; Barbuda (+1268)
                                        </option>
                                        <option data-countrycode="AR" value="54">Argentina (+54)</option>
                                        <option data-countrycode="AM" value="374">Armenia (+374)</option>
                                        <option data-countrycode="AW" value="297">Aruba (+297)</option>
                                        <option data-countrycode="SHAC" value="247">Ascension island (+247)</option>
                                        <option data-countrycode="AT" value="43">Austria (+43)</option>
                                        <option data-countrycode="AQ" value="672">Australian Antarctic Territory
                                            (+672)
                                        </option>
                                        <option data-countrycode="AT" value="672">Australian External Territories
                                            (+672)
                                        </option>
                                        <option data-countrycode="AZ" value="994">Azerbaijan (+994)</option>
                                        <option data-countrycode="BS" value="1242">Bahamas (+1242)</option>
                                        <option data-countrycode="BH" value="973">Bahrain (+973)</option>
                                        <option data-countrycode="BD" value="880">Bangladesh (+880)</option>
                                        <option data-countrycode="BB" value="1246">Barbados (+1246)</option>
                                        <option data-countrycode="AG" value="1268">Barbuda (+1268)</option>
                                        <option data-countrycode="BY" value="375">Belarus (+375)</option>
                                        <option data-countrycode="BE" value="32">Belgium (+32)</option>
                                        <option data-countrycode="BZ" value="501">Belize (+501)</option>
                                        <option data-countrycode="BJ" value="229">Benin (+229)</option>
                                        <option data-countrycode="BM" value="1441">Bermuda (+1441)</option>
                                        <option data-countrycode="BT" value="975">Bhutan (+975)</option>
                                        <option data-countrycode="BO" value="591">Bolivia (+591)</option>
                                        <option data-countrycode="BN" value="5997">Bonaire (+5997)</option>
                                        <option data-countrycode="BA" value="387">Bosnia Herzegovina (+387)</option>
                                        <option data-countrycode="BW" value="267">Botswana (+267)</option>
                                        <option data-countrycode="BR" value="55">Brazil (+55)</option>
                                        <option data-countrycode="IOT" value="246">British Indian Ocean Territory
                                            (+246)
                                        </option>
                                        <option data-countrycode="VGB" value="284">British Virgin Islands (+284)
                                        </option>
                                        <option data-countrycode="BN" value="673">Brunei (+673)</option>
                                        <option data-countrycode="BG" value="359">Bulgaria (+359)</option>
                                        <option data-countrycode="BF" value="226">Burkina Faso (+226)</option>
                                        <option data-countrycode="BI" value="257">Burundi (+257)</option>
                                        <option data-countrycode="BI" value="5993">Caribbean Netherlands (+5993)
                                        </option>
                                        <option data-countrycode="KH" value="855">Cambodia (+855)</option>
                                        <option data-countrycode="CM" value="237">Cameroon (+237)</option>
                                        <option data-countrycode="CA" value="1">Canada (+1)</option>
                                        <option data-countrycode="CV" value="238">Cape Verde Islands (+238)</option>
                                        <option data-countrycode="KY" value="1345">Cayman Islands (+1345)</option>
                                        <option data-countrycode="KY" value="243">Congo, Democratic Republic of the
                                            (Zaire) (+243)
                                        </option>
                                        <option data-countrycode="CF" value="236">Central African Republic (+236)
                                        </option>
                                        <option data-countrycode="TCD" value="235">Chad (+235)</option>
                                        <option data-countrycode="CL" value="56">Chile (+56)</option>
                                        <option data-countrycode="CXR" value="61">Christmas Island (+61)</option>
                                        <option data-countrycode="CCK" value="61">Cocos Islands (+61)</option>
                                        <option data-countrycode="CO" value="57">Colombia (+57)</option>
                                        <option data-countrycode="KM" value="269">Comoros (+269)</option>
                                        <option data-countrycode="CG" value="242">Congo (+242)</option>
                                        <option data-countrycode="CK" value="682">Cook Islands (+682)</option>
                                        <option data-countrycode="CR" value="506">Costa Rica (+506)</option>
                                        <option data-countrycode="HR" value="385">Croatia (+385)</option>
                                        <option data-countrycode="CU" value="53">Cuba (+53)</option>
                                        <option data-countrycode="CUW" value="599">Curacao (+599)</option>
                                        <option data-countrycode="CY" value="90392">Cyprus North (+90392)</option>
                                        <option data-countrycode="CY" value="357">Cyprus South (+357)</option>
                                        <option data-countrycode="CZ" value="42">Czech Republic (+42)</option>
                                        <option data-countrycode="DK" value="246">Diego Garcia (+246)</option>
                                        <option data-countrycode="DK" value="45">Denmark (+45)</option>
                                        <option data-countrycode="DJ" value="253">Djibouti (+253)</option>
                                        <option data-countrycode="DM" value="1809">Dominica (+1809)</option>
                                        <option data-countrycode="DO" value="1809">Dominican Republic (+1809)
                                        </option>
                                        <option data-countrycode="TLS" value="670">East Timor (+670)</option>
                                        <option data-countrycode="TLS" value="56">Easter Island (+56)</option>
                                        <option data-countrycode="EC" value="593">Ecuador (+593)</option>
                                        <option data-countrycode="EG" value="20">Egypt (+20)</option>
                                        <option data-countrycode="SV" value="503">El Salvador (+503)</option>
                                        <option data-countrycode="GQ" value="240">Equatorial Guinea (+240)</option>
                                        <option data-countrycode="ER" value="291">Eritrea (+291)</option>
                                        <option data-countrycode="EE" value="372">Estonia (+372)</option>
                                        <option data-countrycode="ET" value="251">Ethiopia (+251)</option>
                                        <option data-countrycode="FK" value="500">Falkland Islands (+500)</option>
                                        <option data-countrycode="FO" value="298">Faroe Islands (+298)</option>
                                        <option data-countrycode="FJ" value="679">Fiji (+679)</option>
                                        <option data-countrycode="FI" value="358">Finland (+358)</option>
                                        <option data-countrycode="FR" value="33">France (+33)</option>
                                        <option data-countrycode="GF" value="596">French Antilles (+596)</option>
                                        <option data-countrycode="GF" value="594">French Guiana (+594)</option>
                                        <option data-countrycode="PF" value="689">French Polynesia (+689)</option>
                                        <option data-countrycode="GA" value="241">Gabon (+241)</option>
                                        <option data-countrycode="GM" value="220">Gambia (+220)</option>
                                        <option data-countrycode="GE" value="7880">Georgia (+7880)</option>
                                        <option data-countrycode="DE" value="49">Germany (+49)</option>
                                        <option data-countrycode="GH" value="233">Ghana (+233)</option>
                                        <option data-countrycode="GI" value="350">Gibraltar (+350)</option>
                                        <option data-countrycode="GR" value="30">Greece (+30)</option>
                                        <option data-countrycode="GL" value="299">Greenland (+299)</option>
                                        <option data-countrycode="GD" value="1473">Grenada (+1473)</option>
                                        <option data-countrycode="GP" value="590">Guadeloupe (+590)</option>
                                        <option data-countrycode="GU" value="671">Guam (+671)</option>
                                        <option data-countrycode="GT" value="502">Guatemala (+502)</option>
                                        <option data-countrycode="GGY" value="44">Guernsey (+44)</option>
                                        <option data-countrycode="GN" value="224">Guinea (+224)</option>
                                        <option data-countrycode="GW" value="245">Guinea - Bissau (+245)</option>
                                        <option data-countrycode="GY" value="592">Guyana (+592)</option>
                                        <option data-countrycode="HT" value="509">Haiti (+509)</option>
                                        <option data-countrycode="HN" value="504">Honduras (+504)</option>
                                        <option data-countrycode="HK" value="852">Hong Kong (+852)</option>
                                        <option data-countrycode="HU" value="36">Hungary (+36)</option>
                                        <option data-countrycode="IS" value="354">Iceland (+354)</option>
                                        <option data-countrycode="ID" value="62">Indonesia (+62)</option>
                                        <option data-countrycode="IQ" value="964">Iraq (+964)</option>
                                        <option data-countrycode="IE" value="353">Ireland (+353)</option>
                                        <option data-countrycode="IMN" value="44">Isle of Man (+44)</option>
                                        <option data-countrycode="IL" value="972">Israel (+972)</option>
                                        <option data-countrycode="CIV" value="225">Ivory Coast (+225)</option>
                                        <option data-countrycode="JM" value="1876">Jamaica (+1876)</option>
                                        <option data-countrycode="JEY" value="44">Jersey (+44)</option>
                                        <option data-countrycode="JO" value="962">Jordan (+962)</option>
                                        <option data-countrycode="KZ" value="7">Kazakhstan (+7)</option>
                                        <option data-countrycode="KE" value="254">Kenya (+254)</option>
                                        <option data-countrycode="KI" value="686">Kiribati (+686)</option>
                                        <option data-countrycode="XKX" value="383">Kosovo (+383)</option>
                                        <option data-countrycode="KW" value="965">Kuwait (+965)</option>
                                        <option data-countrycode="KG" value="996">Kyrgyzstan (+996)</option>
                                        <option data-countrycode="LA" value="856">Laos (+856)</option>
                                        <option data-countrycode="LV" value="371">Latvia (+371)</option>
                                        <option data-countrycode="LB" value="961">Lebanon (+961)</option>
                                        <option data-countrycode="LS" value="266">Lesotho (+266)</option>
                                        <option data-countrycode="LR" value="231">Liberia (+231)</option>
                                        <option data-countrycode="LY" value="218">Libya (+218)</option>
                                        <option data-countrycode="LI" value="417">Liechtenstein (+417)</option>
                                        <option data-countrycode="LT" value="370">Lithuania (+370)</option>
                                        <option data-countrycode="LU" value="352">Luxembourg (+352)</option>
                                        <option data-countrycode="MO" value="853">Macao (+853)</option>
                                        <option data-countrycode="MK" value="389">Macedonia (+389)</option>
                                        <option data-countrycode="MG" value="261">Madagascar (+261)</option>
                                        <option data-countrycode="MW" value="265">Malawi (+265)</option>
                                        <option data-countrycode="MY" value="60">Malaysia (+60)</option>
                                        <option data-countrycode="MV" value="960">Maldives (+960)</option>
                                        <option data-countrycode="ML" value="223">Mali (+223)</option>
                                        <option data-countrycode="MT" value="356">Malta (+356)</option>
                                        <option data-countrycode="MH" value="692">Marshall Islands (+692)</option>
                                        <option data-countrycode="MQ" value="596">Martinique (+596)</option>
                                        <option data-countrycode="MR" value="222">Mauritania (+222)</option>
                                        <option data-countrycode="MUS" value="230">Mauritius (+230)</option>
                                        <option data-countrycode="YT" value="269">Mayotte (+269)</option>
                                        <option data-countrycode="MX" value="52">Mexico (+52)</option>
                                        <option data-countrycode="FM" value="691">Micronesia (+691)</option>
                                        <option data-countrycode="MD" value="373">Moldova (+373)</option>
                                        <option data-countrycode="MC" value="377">Monaco (+377)</option>
                                        <option data-countrycode="MN" value="976">Mongolia (+976)</option>
                                        <option data-countrycode="MS" value="1664">Montserrat (+1664)</option>
                                        <option data-countrycode="MNE" value="382">Montenegro (+382)</option>
                                        <option data-countrycode="MA" value="212">Morocco (+212)</option>
                                        <option data-countrycode="MZ" value="258">Mozambique (+258)</option>
                                        <option data-countrycode="MN" value="95">Myanmar (+95)</option>
                                        <option data-countrycode="NA" value="264">Namibia (+264)</option>
                                        <option data-countrycode="NR" value="674">Nauru (+674)</option>
                                        <option data-countrycode="NP" value="977">Nepal (+977)</option>
                                        <option data-countrycode="NL" value="31">Netherlands (+31)</option>
                                        <option data-countrycode="ANT" value="599">Netherlands Antilles (+599)
                                        </option>
                                        <option data-countrycode="NC" value="687">New Caledonia (+687)</option>
                                        <option data-countrycode="NZ" value="64">New Zealand (+64)</option>
                                        <option data-countrycode="NI" value="505">Nicaragua (+505)</option>
                                        <option data-countrycode="NE" value="227">Niger (+227)</option>
                                        <option data-countrycode="NG" value="234">Nigeria (+234)</option>
                                        <option data-countrycode="NU" value="683">Niue (+683)</option>
                                        <option data-countrycode="NF" value="672">Norfolk Islands (+672)</option>
                                        <option data-countrycode="KP" value="850">North Korea (+850)</option>
                                        <option data-countrycode="NP" value="670">Northern Marianas (+670)</option>
                                        <option data-countrycode="NO" value="47">Norway (+47)</option>
                                        <option data-countrycode="OM" value="968">Oman (+968)</option>
                                        <option data-countrycode="PK" value="92">Pakistan (+92)</option>
                                        <option data-countrycode="PW" value="680">Palau (+680)</option>
                                        <option data-countrycode="PSE" value="970">Palestine (+970)</option>
                                        <option data-countrycode="PA" value="507">Panama (+507)</option>
                                        <option data-countrycode="PG" value="675">Papua New Guinea (+675)</option>
                                        <option data-countrycode="PY" value="595">Paraguay (+595)</option>
                                        <option data-countrycode="PE" value="51">Peru (+51)</option>
                                        <option data-countrycode="PH" value="63">Philippines (+63)</option>
                                        <option data-countrycode="PCN" value="64">Pitcairn (+64)</option>
                                        <option data-countrycode="PL" value="48">Poland (+48)</option>
                                        <option data-countrycode="PT" value="351">Portugal (+351)</option>
                                        <option data-countrycode="PR" value="1787">Puerto Rico (+1787)</option>
                                        <option data-countrycode="QA" value="974">Qatar (+974)</option>
                                        <option data-countrycode="RE" value="262">Reunion (+262)</option>
                                        <option data-countrycode="RO" value="40">Romania (+40)</option>
                                        <option data-countrycode="RU" value="7">Russia (+7)</option>
                                        <option data-countrycode="RW" value="250">Rwanda (+250)</option>
                                        <option data-countrycode="WSM" value="685">Samoa (+685)</option>
                                        <option data-countrycode="SM" value="378">San Marino (+378)</option>
                                        <option data-countrycode="ST" value="239">Sao Tome &amp; Principe (+239)
                                        </option>
                                        <option data-countrycode="SA" value="966">Saudi Arabia (+966)</option>
                                        <option data-countrycode="SN" value="221">Senegal (+221)</option>
                                        <option data-countrycode="CS" value="381">Serbia (+381)</option>
                                        <option data-countrycode="SC" value="248">Seychelles (+248)</option>
                                        <option data-countrycode="SL" value="232">Sierra Leone (+232)</option>
                                        <option data-countrycode="SXM" value="1721">Sint Maarten (+1721)</option>
                                        <option data-countrycode="SK" value="421">Slovak Republic (+421)</option>
                                        <option data-countrycode="SI" value="386">Slovenia (+386)</option>
                                        <option data-countrycode="SB" value="677">Solomon Islands (+677)</option>
                                        <option data-countrycode="SO" value="252">Somalia (+252)</option>
                                        <option data-countrycode="ZA" value="27">South Africa (+27)</option>
                                        <option data-countrycode="ES" value="34">Spain (+34)</option>
                                        <option data-countrycode="LK" value="94">Sri Lanka (+94)</option>
                                        <option data-countrycode="BLM" value="590">St. Barthelemy (+590)</option>
                                        <option data-countrycode="SH" value="290">St. Helena (+290)</option>
                                        <option data-countrycode="KN" value="1869">St. Kitts (+1869)</option>
                                        <option data-countrycode="SC" value="1758">St. Lucia (+1758)</option>
                                        <option data-countrycode="MAF" value="590">St. Martin (+590)</option>
                                        <option data-countrycode="SPM" value="508">St. Pierre and Miquelon (+508)
                                        </option>
                                        <option data-countrycode="VCT" value="1784">St. Vincent and the Grenadines
                                            (+1784)
                                        </option>
                                        <option data-countrycode="SD" value="249">Sudan (+249)</option>
                                        <option data-countrycode="SR" value="597">Suriname (+597)</option>
                                        <option data-countrycode="SJM" value="47">Svalbard and Jan Mayen (+47)
                                        </option>
                                        <option data-countrycode="SZ" value="268">Swaziland (+268)</option>
                                        <option data-countrycode="SE" value="46">Sweden (+46)</option>
                                        <option data-countrycode="CH" value="41">Switzerland (+41)</option>
                                        <option data-countrycode="SI" value="963">Syria (+963)</option>
                                        <option data-countrycode="TW" value="886">Taiwan (+886)</option>
                                        <option data-countrycode="TJ" value="7">Tajikstan (+7)</option>
                                        <option data-countrycode="TZA" value="255">Tanzania (+255)</option>
                                        <option data-countrycode="TG" value="228">Togo (+228)</option>
                                        <option data-countrycode="TO" value="676">Tonga (+676)</option>
                                        <option data-countrycode="TKL" value="690">Tokelau (+690)</option>
                                        <option data-countrycode="TT" value="1868">Trinidad &amp; Tobago (+1868)
                                        </option>
                                        <option data-countrycode="TN" value="216">Tunisia (+216)</option>
                                        <option data-countrycode="TR" value="90">Turkey (+90)</option>
                                        <option data-countrycode="TM" value="7">Turkmenistan (+7)</option>
                                        <option data-countrycode="TM" value="993">Turkmenistan (+993)</option>
                                        <option data-countrycode="TC" value="1649">Turks &amp; Caicos Islands
                                            (+1649)
                                        </option>
                                        <option data-countrycode="TV" value="688">Tuvalu (+688)</option>
                                        <option data-countrycode="UG" value="256">Uganda (+256)</option>
                                        <option data-countrycode="GB" value="44">UK (+44)</option>
                                        <option data-countrycode="UA" value="380">Ukraine (+380)</option>
                                        <option data-countrycode="AE" value="971">United Arab Emirates (+971)
                                        </option>
                                        <option data-countrycode="UY" value="598">Uruguay (+598)</option>
                                        <option data-countrycode="US" value="1">USA (+1)</option>
                                        <option data-countrycode="UZ" value="7">Uzbekistan (+7)</option>
                                        <option data-countrycode="VU" value="678">Vanuatu (+678)</option>
                                        <option data-countrycode="VA" value="379">Vatican City (+379)</option>
                                        <option data-countrycode="VE" value="58">Venezuela (+58)</option>
                                        <option data-countrycode="VN" value="84">Vietnam (+84)</option>
                                        <option data-countrycode="VG" value="84">Virgin Islands - British (+1284)
                                        </option>
                                        <option data-countrycode="VI" value="84">Virgin Islands - US (+1340)
                                        </option>
                                        <option data-countrycode="WF" value="681">Wallis &amp; Futuna (+681)
                                        </option>
                                        <option data-countrycode="ESH" value="212">Western Sahara (+212)</option>
                                        <option data-countrycode="YE" value="969">Yemen (North)(+969)</option>
                                        <option data-countrycode="YE" value="967">Yemen (South)(+967)</option>
                                        <option data-countrycode="ZM" value="260">Zambia (+260)</option>
                                        <option data-countrycode="ZW" value="263">Zimbabwe (+263)</option>
                                    </optgroup>

                                </select>
                            </div>
                            <div class="col form-label-group required">
                                <input [(ngModel)]="_newMYSJContact" type="tel"
                                    oninput="this.value=this.value.replace(/[^\d]/,'')" name="contactNumber"
                                    placeholder="Mobile No." class="form-control" minlength="7" maxlength="15"
                                    autocomplete="off" value="">
                            </div>
                        </div>
                    </div>

                    <div *ngIf="_newMYSJType == 2" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"
                        ng-reflect-ngb-tooltip="1">
                        <input [(ngModel)]="_newMYSJEmail" size="50" id="newMYSJId" type="email" name="email" id="email"
                            placeholder="Email" ng-reflect-model="1">
                    </div>
                </div>

                <div class="w-100 float-left" style="text-align: center;">
                    <h6 class="mb-lg-0 text-truncate text-primary" (click)="toggleIdType()">
                        {{_newMYSJType == 2 ? "New MySJ ID is a phone number​" : "New MySJ ID is an Email"}} </h6>
                </div>


            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeRoleModal()">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="changeMYSJId(confirmationModal)">Confirm</button>
        </div>
    </div>
</ng-template>

<!-- Employee update modal -->
<ng-template #employeeModal let-modal>
    <div id="divdata">
        <div class="modal-header">
            <h6 class="modal-title medium">Edit Employee​</h6>
            <button type="button" class="close" aria-label="Close" (click)="closeRoleModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="w-100 float-left modal-body">

            <div class="form-group">

                <div class="w-100 float-left p-md-2">
                    <div class="col-lg-3 float-left text-right">
                        Date of birth:
                    </div>

                    <div class="col-lg-8  float-left" ng-reflect-ngb-tooltip="1">
                        <div class="w-100 float-left relative">
                            <input class="form-control" [ngStyle]="{'background-color':'white'}"
                                placeholder="YYYY-MM-DD" name="dateOfBirth" [(ngModel)]="_activeEmployee.dateOfBirth"
                                ngbDatepicker #dob="ngbDatepicker"
                                readonly>
                            <button class="iga-right" (click)="dob.toggle(); openDatePicker(dob)" type="button">
                                <i class="fa fa-calendar"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="w-100 float-left p-md-2">
                    <div class="col-lg-3 float-left text-right">
                        Passport:
                    </div>

                    <div class="col-lg-8  float-left" ng-reflect-ngb-tooltip="1">
                        <input class="form-control" [(ngModel)]="_activeEmployee.passportNumber"
                            [disabled]="_activeEmployee.nationality != 'Malaysian'" name="passportNumber"
                            id="passportNumber" ng-reflect-model="1">
                    </div>
                </div>

                <div class="w-100 float-left p-md-2">
                    <div class="col-lg-3 float-left text-right">
                        Address:
                    </div>

                    <div class="col-lg-8  float-left" ng-reflect-ngb-tooltip="1">
                        <textarea class="form-control" [(ngModel)]="_activeEmployee.address" id="address" name="address"
                            cols="70" ng-reflect-model="1">
                        </textarea>
                    </div>
                </div>

                <div class="w-100 float-left p-md-2">
                    <div class="col-lg-3 float-left text-right">
                        Area:
                    </div>

                    <div class="col-lg-8  float-left" ng-reflect-ngb-tooltip="1">
                        <input class="form-control" [(ngModel)]="_activeEmployee.postcode" name="postcode" id="postcode"
                            ng-reflect-model="1">
                    </div>
                </div>

                <div class="w-100 float-left p-md-2">
                    <div class="col-lg-3 float-left text-right">
                        State:
                    </div>

                    <div class="col-lg-8  float-left" ng-reflect-ngb-tooltip="1">
                        <select [(ngModel)]="_activeEmployee.orgCode" class="form-control custom-select" name="state"
                            id="state">
                            <option *ngFor="let state of states" [value]="state.orgUnitCode"
                                [attr.selected]="_activeEmployee.orgCode==state.orgUnitCode">
                                {{state.orgName}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="w-100 float-left p-md-2">
                    <div class="col-lg-3 float-left text-right">
                        Nationality:
                    </div>

                    <div class="col-lg-8  float-left" ng-reflect-ngb-tooltip="1">
                        <select [(ngModel)]="_activeEmployee.nationality" class="form-control custom-select"
                            name="nationality" id="nationality"  (change)="onNationalityChange()">
                            <option value="Malaysian">Malaysian</option>
                            <option value="Afghan">Afghan</option>
                            <option value="Albanian">Albanian</option>
                            <option value="Algerian">Algerian</option>
                            <option value="American">American</option>
                            <option value="Andorran">Andorran</option>
                            <option value="Angolan">Angolan</option>
                            <option value="Anguillan">Anguillan</option>
                            <option value="Argentine">Argentine</option>
                            <option value="Armenian">Armenian</option>
                            <option value="Australian">Australian</option>
                            <option value="Austrian">Austrian</option>
                            <option value="Azerbaijani">Azerbaijani</option>
                            <option value="Bahamian">Bahamian</option>
                            <option value="Bahraini">Bahraini</option>
                            <option value="Bangladeshi">Bangladeshi</option>
                            <option value="Barbadian">Barbadian</option>
                            <option value="Belarusian">Belarusian</option>
                            <option value="Belgian">Belgian</option>
                            <option value="Belizean">Belizean</option>
                            <option value="Beninese">Beninese</option>
                            <option value="Bhutanese">Bhutanese</option>
                            <option value="Bolivian">Bolivian</option>
                            <option value="Botswanan">Botswanan</option>
                            <option value="Brazilian">Brazilian</option>
                            <option value="British">British</option>
                            <option value="British Virgin Islander">British Virgin Islander</option>
                            <option value="Bruneian">Bruneian</option>
                            <option value="Bulgarian">Bulgarian</option>
                            <option value="Burkinan">Burkinan</option>
                            <option value="Burmese">Burmese</option>
                            <option value="Bermudian">Bermudian</option>
                            <option value="Burundian">Burundian</option>
                            <option value="Cambodian">Cambodian</option>
                            <option value="Cameroonian">Cameroonian</option>
                            <option value="Canadian">Canadian</option>
                            <option value="Cape Verdean">Cape Verdean</option>
                            <option value="Cayman Islander">Cayman Islander</option>
                            <option value="Central African">Central African</option>
                            <option value="Chadian">Chadian</option>
                            <option value="Chilean">Chilean</option>
                            <option value="Chinese">Chinese</option>
                            <option value="Citizen of Antigua and Barbuda">Citizen of Antigua and Barbuda</option>
                            <option value="Citizen of Bosnia and Herzegovina">Citizen of Bosnia and Herzegovina</option>
                            <option value="Citizen of the Dominican Republic">Citizen of the Dominican Republic</option>
                            <option value="Citizen of Guinea-Bissau">Citizen of Guinea-Bissau</option>
                            <option value="Citizen of Kiribati">Citizen of Kiribati</option>
                            <option value="Citizen of Seychelles">Citizen of Seychelles</option>
                            <option value="Citizen of Vanuatu">Citizen of Vanuatu</option>
                            <option value="Colombian">Colombian</option>
                            <option value="Comoran">Comoran</option>
                            <option value="Congolese (Congo)">Congolese (Congo)</option>
                            <option value="Congolese (DRC)">Congolese (DRC)</option>
                            <option value="Cook Islander">Cook Islander</option>
                            <option value="Costa Rican">Costa Rican</option>
                            <option value="Croatian">Croatian</option>
                            <option value="Cuban">Cuban</option>
                            <option value="Cymraes">Cymraes</option>
                            <option value="Cymro">Cymro</option>
                            <option value="Cypriot">Cypriot</option>
                            <option value="Czech">Czech</option>
                            <option value="Danish">Danish</option>
                            <option value="Djiboutian">Djiboutian</option>
                            <option value="Dominican">Dominican</option>
                            <option value="Dutch">Dutch</option>
                            <option value="East Timorese">East Timorese</option>
                            <option value="Ecuadorean">Ecuadorean</option>
                            <option value="Egyptian">Egyptian</option>
                            <option value="Emirati">Emirati</option>
                            <option value="English">English</option>
                            <option value="Equatorial Guinean">Equatorial Guinean</option>
                            <option value="Eritrean">Eritrean</option>
                            <option value="Estonian">Estonian</option>
                            <option value="Ethiopian">Ethiopian</option>
                            <option value="Faroese">Faroese</option>
                            <option value="Fijian">Fijian</option>
                            <option value="Filipino">Filipino</option>
                            <option value="Finnish">Finnish</option>
                            <option value="French">French</option>
                            <option value="Gabonese">Gabonese</option>
                            <option value="Gambian">Gambian</option>
                            <option value="Georgian">Georgian</option>
                            <option value="German">German</option>
                            <option value="Ghanaian">Ghanaian</option>
                            <option value="Gibraltarian">Gibraltarian</option>
                            <option value="Greek">Greek</option>
                            <option value="Greenlandic">Greenlandic</option>
                            <option value="Grenadian">Grenadian</option>
                            <option value="Guamanian">Guamanian</option>
                            <option value="Guatemalan">Guatemalan</option>
                            <option value="Guinean">Guinean</option>
                            <option value="Guyanese">Guyanese</option>
                            <option value="Haitian">Haitian</option>
                            <option value="Honduran">Honduran</option>
                            <option value="Hong Konger">Hong Konger</option>
                            <option value="Hungarian">Hungarian</option>
                            <option value="Icelandic">Icelandic</option>
                            <option value="Indian">Indian</option>
                            <option value="Indonesian">Indonesian</option>
                            <option value="Irish">Irish</option>
                            <option value="Iraqi">Iraqi</option>
                            <option value="Iranian">Iranian</option>
                            <option value="Israeli">Israeli</option>
                            <option value="Italian">Italian</option>
                            <option value="Ivorian">Ivorian</option>
                            <option value="Jamaican">Jamaican</option>
                            <option value="Japanese">Japanese</option>
                            <option value="Jordanian">Jordanian</option>
                            <option value="Kazakh">Kazakh</option>
                            <option value="Kenyan">Kenyan</option>
                            <option value="Kittitian">Kittitian</option>
                            <option value="Kosovan">Kosovan</option>
                            <option value="Kuwaiti">Kuwaiti</option>
                            <option value="Kyrgyz">Kyrgyz</option>
                            <option value="Lao">Lao</option>
                            <option value="Latvian">Latvian</option>
                            <option value="Lebanese">Lebanese</option>
                            <option value="Liberian">Liberian</option>
                            <option value="Libyan">Libyan</option>
                            <option value="Liechtenstein citizen">Liechtenstein citizen</option>
                            <option value="Lithuanian">Lithuanian</option>
                            <option value="Luxembourger">Luxembourger</option>
                            <option value="Macanese">Macanese</option>
                            <option value="Macedonian">Macedonian</option>
                            <option value="Malagasy">Malagasy</option>
                            <option value="Malawian">Malawian</option>
                            <option value="Maldivian">Maldivian</option>
                            <option value="Malian">Malian</option>
                            <option value="Maltese">Maltese</option>
                            <option value="Marshallese">Marshallese</option>
                            <option value="Martiniquais">Martiniquais</option>
                            <option value="Mauritanian">Mauritanian</option>
                            <option value="Mauritian">Mauritian</option>
                            <option value="Mexican">Mexican</option>
                            <option value="Micronesian">Micronesian</option>
                            <option value="Moldovan">Moldovan</option>
                            <option value="Monegasque">Monegasque</option>
                            <option value="Mongolian">Mongolian</option>
                            <option value="Montenegrin">Montenegrin</option>
                            <option value="Montserratian">Montserratian</option>
                            <option value="Moroccan">Moroccan</option>
                            <option value="Mosotho">Mosotho</option>
                            <option value="Mozambican">Mozambican</option>
                            <option value="Namibian">Namibian</option>
                            <option value="Nauruan">Nauruan</option>
                            <option value="Nepalese">Nepalese</option>
                            <option value="New Zealander">New Zealander</option>
                            <option value="Nicaraguan">Nicaraguan</option>
                            <option value="Nigerien">Nigerien</option>
                            <option value="Niger Republic">Niger Republic</option>
                            <option value="Niuean">Niuean</option>
                            <option value="North Korean">North Korean</option>
                            <option value="Northern Irish">Northern Irish</option>
                            <option value="Norwegian">Norwegian</option>
                            <option value="Omani">Omani</option>
                            <option value="Pakistani">Pakistani</option>
                            <option value="Palauan">Palauan</option>
                            <option value="Palestinian">Palestinian</option>
                            <option value="Panamanian">Panamanian</option>
                            <option value="Papua New Guinean">Papua New Guinean</option>
                            <option value="Paraguayan">Paraguayan</option>
                            <option value="Peruvian">Peruvian</option>
                            <option value="Pitcairn Islander">Pitcairn Islander</option>
                            <option value="Polish">Polish</option>
                            <option value="Portuguese">Portuguese</option>
                            <option value="Prydeinig">Prydeinig</option>
                            <option value="Puerto Rican">Puerto Rican</option>
                            <option value="Qatari">Qatari</option>
                            <option value="Romanian">Romanian</option>
                            <option value="Russian">Russian</option>
                            <option value="Rwandan">Rwandan</option>
                            <option value="Salvadorean">Salvadorean</option>
                            <option value="Samoan">Samoan</option>
                            <option value="Sammarinese">Sammarinese</option>
                            <option value="Sao Tomean">Sao Tomean</option>
                            <option value="Saudi Arabian">Saudi Arabian</option>
                            <option value="Scottish">Scottish</option>
                            <option value="Senegalese">Senegalese</option>
                            <option value="Serbian">Serbian</option>
                            <option value="Sierra Leonean">Sierra Leonean</option>
                            <option value="Singaporean">Singaporean</option>
                            <option value="Slovak">Slovak</option>
                            <option value="Slovenian">Slovenian</option>
                            <option value="Solomon Islander">Solomon Islander</option>
                            <option value="Somali">Somali</option>
                            <option value="South African">South African</option>
                            <option value="South Korean">South Korean</option>
                            <option value="South Sudanese">South Sudanese</option>
                            <option value="Spanish">Spanish</option>
                            <option value="Sri Lankan">Sri Lankan</option>
                            <option value="St Helenian">St Helenian</option>
                            <option value="St Lucian">St Lucian</option>
                            <option value="Stateless">Stateless</option>
                            <option value="Sudanese">Sudanese</option>
                            <option value="Surinamese">Surinamese</option>
                            <option value="Swazi">Swazi</option>
                            <option value="Swedish">Swedish</option>
                            <option value="Swiss">Swiss</option>
                            <option value="Syrian">Syrian</option>
                            <option value="Taiwanese">Taiwanese</option>
                            <option value="Tajik">Tajik</option>
                            <option value="Tanzanian">Tanzanian</option>
                            <option value="Thai">Thai</option>
                            <option value="Togolese">Togolese</option>
                            <option value="Tongan">Tongan</option>
                            <option value="Trinidadian">Trinidadian</option>
                            <option value="Tristanian">Tristanian</option>
                            <option value="Tunisian">Tunisian</option>
                            <option value="Turkish">Turkish</option>
                            <option value="Turkmen">Turkmen</option>
                            <option value="Turks and Caicos Islander">Turks and Caicos Islander</option>
                            <option value="Tuvaluan">Tuvaluan</option>
                            <option value="Ugandan">Ugandan</option>
                            <option value="Ukrainian">Ukrainian</option>
                            <option value="Uruguayan">Uruguayan</option>
                            <option value="Uzbek">Uzbek</option>
                            <option value="Vatican citizen">Vatican citizen</option>
                            <option value="Venezuelan">Venezuelan</option>
                            <option value="Vietnamese">Vietnamese</option>
                            <option value="Vincentian">Vincentian</option>
                            <option value="Wallisian">Wallisian</option>
                            <option value="Welsh">Welsh</option>
                            <option value="Yemeni">Yemeni</option>
                            <option value="Zambian">Zambian</option>
                            <option value="Zimbabwean">Zimbabwean</option>
                        </select>
                    </div>
                </div>

                <div class="w-100 float-left p-md-2">
                    <div class="col-lg-3 float-left text-right">
                        Reason: <span class="text-danger medium">*</span>
                    </div>

                    <div class="col-lg-8  float-left" ng-reflect-ngb-tooltip="1">
                        <input class="form-control" [(ngModel)]="_activeEmployee.reason" size="60" name="reason"
                            id="reason" ng-reflect-model="1">
                    </div>
                </div>

            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeRoleModal()">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="updateEmployee(confirmationModal)">Update</button>
        </div>
    </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/employee/employeeList.html